import Hls from 'hls.js';
import { getVideoOptions } from './config';

let hlsInstance: Hls | undefined = undefined;

export function initHls(videoId: string) {
  destroyHls();

  const recordingVideo = document.getElementById('recordingVideo') as HTMLVideoElement;

  let videoSrc: string;

  if (videoId) {
    const version = Math.random().toString().substring(2);
    videoSrc = `${getVideoOptions().VIDEO_RECORDINGS_ROOT_URL}/${videoId}/playlist.m3u8?v=${version}`;
  } else {
    console.error('videoId does not exist, invalid playlist.m3u8 URL');
    return;
  }

  if (Hls.isSupported()) {
    hlsInstance = new Hls();
    hlsInstance.on(Hls.Events.ERROR, (_event, data) => {
      if (data.fatal && data.type === Hls.ErrorTypes.NETWORK_ERROR) {
        console.error(`[PlaybackService] Fatal HLS network error: ${data.details}`, data);
        hlsInstance?.destroy();
        hlsInstance = undefined;
        recordingVideo.style.display = 'none';
        const errorContainer = document.getElementById('recordingUnavailable');
        if (errorContainer) {
          errorContainer.style.display = '';
        }
      }
    });
    hlsInstance.loadSource(videoSrc);
    hlsInstance.attachMedia(recordingVideo);
  } else if (recordingVideo.canPlayType('application/vnd.apple.mpegurl')) {
    recordingVideo.src = videoSrc;
  }
}

export function destroyHls() {
  if (hlsInstance) {
    hlsInstance.destroy();
    hlsInstance = undefined;
    console.log('HLS instance destroyed');
  }
}
